import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import { i18n } from './i18n';
import { tilt } from './directives/tilt';
import { reveal } from './directives/reveal';
import { fetchSiteMeta } from './api/meta';
import { applySiteMeta } from './utils/meta';

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(i18n);
app.directive('tilt', tilt);
app.directive('reveal', reveal);
app.mount('#app');

// Admin site meta overrides (title, description, share image, favicons).
// Not awaited: index.html's static tags stand in until it lands, and a
// failed fetch just keeps them.
fetchSiteMeta().then(applySiteMeta).catch(() => undefined);
